import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { CONTACT } from "@/data/content";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#2C312E] text-white/80"
        >
            <div className="container-em py-16 md:py-20">
                <div className="grid md:grid-cols-12 gap-10 md:gap-8">
                    <div className="md:col-span-5">
                        <a
                            href="#top"
                            className="inline-flex items-baseline gap-2"
                        >
                            <span className="font-display text-3xl md:text-4xl text-white tracking-tight">
                                Emsglück
                            </span>
                            <span className="text-primary">.</span>
                        </a>
                        <p className="mt-5 max-w-md text-white/60 leading-relaxed">
                            Deine hochwertige Ferienwohnung in Papenburg. Für
                            Projektleiter, Berufsreisende, Familien und
                            Monteure, die Ruhe, Komfort und eine zentrale Lage
                            schätzen.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <p className="font-accent text-xs uppercase tracking-[0.25em] text-white/60">
                            Kontakt
                        </p>
                        <ul className="mt-4 space-y-3">
                            <li>
                                <a
                                    href={`mailto:${CONTACT.email}`}
                                    data-testid="footer-email"
                                    className="inline-flex items-center gap-2 text-white/85 hover:text-white transition-colors"
                                >
                                    <Mail size={15} />
                                    {CONTACT.email}
                                </a>
                            </li>
                            <li className="flex items-start gap-2 text-white/85">
                                <MapPin size={15} className="mt-1 shrink-0" />
                                <span>
                                    {CONTACT.street}
                                    <br />
                                    {CONTACT.city}
                                </span>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="font-accent text-xs uppercase tracking-[0.25em] text-white/60">
                            Rechtliches
                        </p>
                        <ul className="mt-4 space-y-3 text-white/85">
                            <li>
                                <Link
                                    to="/impressum"
                                    data-testid="footer-impressum"
                                    className="hover:text-white transition-colors"
                                >
                                    Impressum
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/datenschutz"
                                    data-testid="footer-datenschutz"
                                    className="hover:text-white transition-colors"
                                >
                                    Datenschutz
                                </Link>
                            </li>
                            <li>
                                <a
                                    href={CONTACT.mailtoContact}
                                    data-testid="footer-contact"
                                    className="hover:text-white transition-colors"
                                >
                                    Kontakt
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-white/50">
                    <p>© {new Date().getFullYear()} Emsglück. Alle Rechte vorbehalten.</p>
                    <p className="font-accent tracking-wider text-xs uppercase">
                        Ankommen · Wohlfühlen · Entspannen
                    </p>
                </div>
            </div>
        </footer>
    );
}
